<div class="product-search p-inputgroup">
  <span class="p-inputgroup-addon color">
    <em (mousedown)="searchProduct($event,search)" class="pi pi-search"></em>
  </span>
  <form autocomplete="off" style="display: contents">
    <input
      (blur)="closeDropDown()"
      (keyup.enter)="searchProduct($event,'')"
      (ngModelChange)="searchChange($event)"
      [(ngModel)]="search"
      [ngModelOptions]="{ standalone: true }"
      autocapitalize="off"
      autocomplete="new-password"
      autocorrect="off"
      pInputText
      placeholder="{{
        scConfig
          ? ('search.scSearchOnMoMoMarket' | translate)
          : ('search.searchOnMoMoMarket' | translate)
      }}"
      spellcheck="false"
      type="text"

    />
  </form>

  <ng-container *ngIf="displayResult">
    <div class="search-results">
      <div class="my-3"></div>
      <div
        (mousedown)="NavigateToProduct(option.specProductId)"
        *ngFor="let option of searchResult; index as i"
        class="px-2 padding-y-5"
        style="cursor: pointer"
      >
        <div>
          <span class="medium-font font-size-14">{{ option.name }}</span>

        </div>
        <div>
          <span class="prop-color">{{ "search.in" | translate }}</span>
          <span
            class="main-color font-size-14 mx-1"
            style="color: #004f71; font-weight: bold"
          >{{ option.categoryName }}</span
          >
        </div>
        <p-divider></p-divider>
      </div>
      <p *ngIf="searchResult && searchResult.length === 0" class="ml-3">
        {{ "searchNotFound" | translate }}
      </p>
    </div>
    <div class="overlay"></div>
  </ng-container>
</div>
